import "@hotwired/turbo-rails";
import { Turbo } from "@hotwired/turbo-rails";

import { application } from "./controllers/application";

import SearchController from "./controllers/search_controller";
application.register("search", SearchController);

import DialogController from "./controllers/dialog_controller";
application.register("dialog", DialogController);

import DirectoryController from "./controllers/directory_controller";
application.register("directory", DirectoryController);

import HiddenTextController from "./controllers/hidden_text_controller";
application.register("hidden-text", HiddenTextController);

import ProfileCardController from "./controllers/profile_card_controller";
application.register("profile-card", ProfileCardController);

import ContactIntentController from "./controllers/contact_intent_controller";
application.register("contact-intent", ContactIntentController);

import ClickMapperController from "./controllers/click_mapper_controller";
application.register("click-mapper", ClickMapperController);

import ModalController from "./controllers/modal_controller";
application.register("modal", ModalController);

import CopyController from "./controllers/copy_controller";
application.register("copy", CopyController);

import LandingController from "./controllers/landing_controller";
application.register("landing", LandingController);

import SidebarController from "./controllers/sidebar_controller";
application.register("sidebar", SidebarController);

import GalleryController from "./controllers/gallery_controller";
application.register("gallery", GalleryController);

import Bridge from "./turbo/bridge";
window.bridge = Bridge;

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
